import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b3293502"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lotto-game-buy" }
const _hoisted_2 = {
  key: 0,
  class: "info-area"
}
const _hoisted_3 = { class: "ball-area" }
const _hoisted_4 = {
  key: 0,
  class: "dummy-ball"
}
const _hoisted_5 = {
  key: 1,
  class: "not-dummy"
}
const _hoisted_6 = {
  key: 0,
  class: "bonus-indicator"
}
const _hoisted_7 = { class: "number" }
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "TERRA" }, "Breezer", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "AUTO" }, "자동", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "MANUAL" }, "수동", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "SEMI_AUTO" }, "반자동", -1))
const _hoisted_13 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "buy-type-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!(_ctx.hideRank && _ctx.lottoGame.rank == 0))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["rank", _ctx.getRankClass(_ctx.lottoGame.rank)])
          }, [
            (_ctx.lottoGame.rank == 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("추첨전")
                ], 64))
              : (_ctx.lottoGame.rank == 6)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("낙첨")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(_ctx.lottoGame.rank) + "등!!", 1)
                  ], 64))
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSortedDrwtWithWin, (ball, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["ball-wrapper", _ctx.getBallClass(ball.number, ball.winCode)])
        }, [
          (ball.isDummy)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (ball.winCode === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, "+"))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["ball", _ctx.getBallClass(ball.number, ball.winCode)])
                }, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(ball.number), 1)
                ], 2)
              ]))
        ], 2))
      }), 128))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["buy-type", 'bt-' + (_ctx.lottoGame.buyType || 'TERRA')])
    }, [
      (_ctx.editMode)
        ? (_openBlock(), _createElementBlock("select", {
            key: 0,
            class: "buy-type-select",
            value: _ctx.lottoGame.buyType || 'TERRA',
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onTypeChange && _ctx.onTypeChange(...args))),
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }, _hoisted_13, 40, _hoisted_8))
        : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.buyTypeLabel), 1))
    ], 2)
  ]))
}